module.exports = __webpack_public_path__ + "media/images/front/more_arrow-53e7e81e2f6deea806ea132f4d15c782.png";